// extracted by mini-css-extract-plugin
export default {"contentWrapper":"style_contentWrapper__qAWDd","xxlScreensize":"style_xxlScreensize__h4Gtb","lgScreenSize":"style_lgScreenSize__7tpFh"};